import React from 'react';
import {defaultTemplate} from 'core/hoc';
import _ from 'lodash';
import { BaasicModal } from 'core/components';
import { TaskCommentsModal } from 'application/dashboard/components';

const TaskNotificationsTemplate = defaultTemplate(({ title, store, t }) => {
    const { 
        onOpenNotifications,
        taskNotificationsModal,
        rootStore
     } = store;

    let facilities = [];

    _.each(rootStore.viewStore.taskNotifications, (groupItems) => {
            facilities.push(<div className="row" onClick={() => 
                    onOpenNotifications({
                        facilityScheduleDateId: groupItems[0].facilityScheduleDate.id,
                        taskName: groupItems[0].taskName
                    })
                }>
                <div className="col">
                    <a>{groupItems[0].taskName}</a>
                    <span className="task-notification__bubble">{groupItems.length}</span>
                </div>
            </div>)
    });

    return (
        <React.Fragment>
            {title && <h4 className="form__title form__title--preview">{t(title)}</h4>}
            {facilities.length > 0 ? facilities :
                    <div className='type--center spc--top--lrg spc--bottom--med'>
                        <p className='spc--top--sml'>No unread notifications</p>
                    </div>}
            <BaasicModal modalParams={taskNotificationsModal}>
                <TaskCommentsModal />
            </BaasicModal>
        </React.Fragment> 
    )
});

export default TaskNotificationsTemplate;